import moment from 'moment';
import { weekDays } from '@data/weekDays';
import { TimelineItemTypeType } from '@app-types/timetable';
import { GetTimeSlotsForAGivenDayArgs, GetTimeSlotsForAGivenDayResult } from '../../types';

export const getTimeSlotForAGivenDay = ({
  timeSlotConfiguration,
  week,
  givenWeekDay,
  timelineItems,
}: GetTimeSlotsForAGivenDayArgs): GetTimeSlotsForAGivenDayResult | null => {
  if (week) {
    // Find the iso day number. monday = 1, tuesday = 2
    const weekDayIndex = weekDays.findIndex((weekDay) => weekDay === givenWeekDay);

    // Set the day according to the selected week and passed week day
    const day = week.clone().isoWeekday(weekDayIndex + 1);
    const startTime = moment(timeSlotConfiguration.startTime);
    const endTime = moment(timeSlotConfiguration.endTime);

    if (timeSlotConfiguration.interval && timelineItems) {
      // Add only if the the same interval does not already exist
      // Match exact day, time and minute of startTime and endTime
      const existingInterval = timelineItems.find(
        (timelineItem) =>
          timelineItem.itemType === TimelineItemTypeType.interval &&
          timelineItem.startTime.day() === day.day() &&
          timelineItem.startTime.hour() === startTime.hour() &&
          timelineItem.startTime.minute() === startTime.minute() &&
          timelineItem.endTime.hour() === endTime.hour() &&
          timelineItem.endTime.minute() === endTime.minute(),
      );

      if (existingInterval) {
        return null;
      }
    }

    return {
      timeSlot: {
        startTime: day.clone().set('hour', startTime.hour()).set('minute', startTime.minute()),
        endTime: day.clone().set('hour', endTime.hour()).set('minute', endTime.minute()),
      },
      interval: timeSlotConfiguration.interval,
    };
  }

  return null;
};
